import {Component, OnInit} from '@angular/core';
import {SearchResult} from "../api/models/search-result";
import {SearchUrlParameters} from "../shared/model/search-url-parameters";

@Component({
  selector: 'app-search-error',
  templateUrl: './search-error.component.html',
  styleUrls: ['./search-error.component.scss']
})
export class SearchErrorComponent {

  searchResult: SearchResult = {searchResultList: []}

  searchParams: SearchUrlParameters = {};

  constructor() {
  }

}
